import BaseAnswerItem from '../../../../common/AnswerItem'

export default class AnswerItem extends BaseAnswerItem {
  readonly id: number
  readonly qId: number
  readonly formId: number
  readonly createdAt: number
  readonly updatedAt: number

  constructor(data: { [key: string]: any }) {
    super(data.name, data.allotment, data.body, data.correct, data.scopeId)
    this.id = data.id
    this.qId = data.qId
    this.formId = data.formId
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
  }
}
